import dayjs, { OpUnitType, QUnitType } from 'dayjs';
import curry from 'lodash-es/curry';

const diff = (
  whatToDiff: OpUnitType | QUnitType,
  firstDate: Date | string,
  secondDate: Date | string,
): number => dayjs(firstDate).diff(dayjs(secondDate), whatToDiff);

export default curry(diff, 3);
